"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function safeParseInt(input, radix) {
    if (radix === void 0) { radix = 10; }
    return typeof input === "number" ? input : parseInt(input, radix);
}
exports.safeParseInt = safeParseInt;
function safeParseFloat(input) {
    return typeof input === "number" ? input : parseFloat(input);
}
exports.safeParseFloat = safeParseFloat;
function safeParseJSON(input, defaultValue) {
    if (defaultValue === void 0) { defaultValue = {}; }
    try {
        return typeof input === "object" ? input : JSON.parse(input);
    }
    catch (e) {
        return defaultValue;
    }
}
exports.safeParseJSON = safeParseJSON;
//# sourceMappingURL=parser.js.map